import { GAME_OVERRIDE } from "vue-chess-shared/constants";

export const MATCH_VARIANT = {
  STANDARD: "standard",
};

export const MATCH_DURATION = {
  BULLET: 60,
  BLITZ: 300,
  RAPID: 900,
  UNLIMITED: null,
};

export const MATCH_DEFAULT = {
  DURATION: MATCH_DURATION.RAPID,
  INCREMENT: 0,
  VARIANT: MATCH_VARIANT.STANDARD,
  AI_LEVEL: 1,
  GAME_OVERRIDE: GAME_OVERRIDE.PVP,
};

export const QUICK_MATCHES = [
  { duration: 1, increment: 0 },
  { duration: 2, increment: 1 },
  { duration: 3, increment: 0 },
  { duration: 3, increment: 2 },
  { duration: 5, increment: 0 },
  { duration: 5, increment: 3 },
  { duration: 10, increment: 0 },
  { duration: 10, increment: 5 },
  { duration: 15, increment: 0 },
  { duration: 15, increment: 10 },
  { duration: 30, increment: 0 },
  { duration: 30, increment: 20 },
];

export const ONLINE_STATUS = {
  ACTIVE: "Active",
  AWAY: "Away",
  BUSY: "Busy",
  PLAYING: "Playing",
  OFFLINE: "Offline",
};

export const REWARD = {
  TROPHY: "Trophy",
  MEDAL: "Medal",
  PARTICIPATION: "Participation",
};

export const TOURNAMENT_TROPHIES = ["Trophy|1", "Trophy|2", "Trophy|3"];
export const TOURNAMENT_MEDALS = ["Medal|1", "Medal|2", "Medal|3"];

// corresponding to
// 100% random - 0 % ai
// 80% random - 20% ai
// and so on ...
export const AI_RANDOM_RATE_BY_LEVEL = [
  1,
  0.8,
  0.68,
  0.56,
  0.45,
  0.35,
  0.25,
  0.15,
  0.075,
  -1,
  -1,
];

export const LESSON_LEVEL = {
  BEGINNER: "beginner",
  ROOKIE: "rookie",
  INTERMEDIATE: "intermediate",
  ADVANCED: "advanced",
};

export const GAME_TYPE = {
  AIvAI: "AivAi",
  PvAI: "PvAi",
  PvP: "PvP",
};

export const SIMUL_PRIVACY = {
  PUBLIC: "Public",
  PRIVATE: "Private",
};

export const SIMUL_REQUEST_STATUS = {
  REQUESTED: "requested",
  REJECTED: "rejected",
  APPROVED: "approved",
};

export const CHALLENGE_TYPE = {
  GAME: "game",
  SIMUL: "simul",
};

export const CHALLENGE_STATUS = {
  SENT: "sent",
  ACCEPTED: "accepted",
};

export const AWARD_TYPE = {
  BEHAVIORAL: "behavioral",
  ACHIEVEMENT: "achievement",
};

// Award constants for the chess awards system from SAC
export const AWARDS = [
  { code: 0, name: "Excellent Behaviour", icon: "blue.png", abbreviation: "E", type: AWARD_TYPE.BEHAVIORAL },
  { code: 1, name: "Amazing Concentration", icon: "green.png", abbreviation: "A", type: AWARD_TYPE.BEHAVIORAL },
  { code: 2, name: "Good Sportsmanship", icon: "orange.png", abbreviation: "GS", type: AWARD_TYPE.BEHAVIORAL },
  { code: 3, name: "Great Problem Solving", icon: "purple.png", abbreviation: "GP", type: AWARD_TYPE.BEHAVIORAL },
  { code: 4, name: "Terrific Effort", icon: "light-blue.png", abbreviation: "T", type: AWARD_TYPE.BEHAVIORAL },
  { code: 5, name: "Unbelievable Improvement", icon: "light-green.png", abbreviation: "U", type: AWARD_TYPE.BEHAVIORAL },
  { code: 6, name: "Most Brilliant Checkmate", icon: "red.png", abbreviation: "MB", type: AWARD_TYPE.BEHAVIORAL },
  { code: 7, name: "Most Clever Tactic", icon: "yellow.png", abbreviation: "MC", type: AWARD_TYPE.BEHAVIORAL },
  { code: 8, name: "Bronze Pawn Award", icon: "bronzepawn.png", abbreviation: "BP", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 9, name: "Silver Knight Award", icon: "silverknight.png", abbreviation: "SK", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 10, name: "Gold King Award", icon: "goldking.png", abbreviation: "GK", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 11, name: "Gold Queen Award", icon: "goldqueen.png", abbreviation: "GQ", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 12, name: "Platinum King Award", icon: "platinumking.png", abbreviation: "PK", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 13, name: "Platinum Queen Award", icon: "platinumqueen.png", abbreviation: "PQ", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 14, name: "Medieval King Award", icon: "medievalking.png", abbreviation: "MK", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 15, name: "Diamond Castling Award", icon: "diamondcastling.png", abbreviation: "DC", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 16, name: "Rainbow Bishop Award", icon: "rainbowbishop.png", abbreviation: "RB", type: AWARD_TYPE.ACHIEVEMENT },
  { code: 17, name: "Rainbow Rook Award", icon: "rainbowrook.png", abbreviation: "RR", type: AWARD_TYPE.ACHIEVEMENT },
];

export const BEHAVIORAL_AWARDS = AWARDS.filter(award => award.type === AWARD_TYPE.BEHAVIORAL);
export const ACHIEVEMENT_AWARDS = AWARDS.filter(award => award.type === AWARD_TYPE.ACHIEVEMENT);
